module.exports = __webpack_public_path__ + "p.no2.82674569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/p.no2.jpg
// module id = 6fch
// module chunks = 0